/**
 * Slot end time parsing for strings like "10:30 AM - 12:00 PM" or "10:30 AM - 12:30 PM"
 */
function parseEndTimeOnDate(slotTimeStr, yyyyMmDd) {
  if (!slotTimeStr || !yyyyMmDd) return null;
  const parts = String(slotTimeStr).split(/\s*-\s*/);
  if (parts.length < 2) return null;
  const endPart = parts[parts.length - 1].trim();
  const [y, mo, d] = yyyyMmDd.split("-").map(Number);
  if (!y || !mo || !d) return null;
  const base = new Date(y, mo - 1, d);

  let match = endPart.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
  if (match) {
    let hours = parseInt(match[1], 10);
    const mins = parseInt(match[2], 10);
    const ap = match[3].toUpperCase();
    if (ap === "PM" && hours !== 12) hours += 12;
    if (ap === "AM" && hours === 12) hours = 0;
    base.setHours(hours, mins, 59, 999);
    return base;
  }

  match = endPart.match(/(\d{1,2}):(\d{2})/);
  if (match) {
    base.setHours(parseInt(match[1], 10), parseInt(match[2], 10), 59, 999);
    return base;
  }

  return null;
}

/**
 * searchSlots marks taken slots with isAvailable=false (see EventsService.prepareSearchResponse).
 * Jackson may expose this as "available" or "isAvailable" depending on visibility settings.
 */
export function isApiSlotUnavailable(slot) {
  if (slot == null) return true;
  if (slot.isAvailable === false || slot.isAvailable === "N") return true;
  if (slot.available === false) return true;
  return false;
}

/**
 * True when slot should not be selectable: API says unavailable / booked, or today's slot window has ended.
 */
export function isSlotDisabled(slot, eventDateStr) {
  if (!slot) return true;
  if (isApiSlotUnavailable(slot)) return true;

  const todayStr = new Date().toISOString().split("T")[0];
  const day = eventDateStr || todayStr;
  if (day < todayStr) return true;

  if (day > todayStr) return false;

  const end = parseEndTimeOnDate(slot.slotTime || "", day);
  if (!end) return false;

  return Date.now() > end.getTime();
}

export function getFirstSelectableSlotIndex(timeslots, eventDateStr) {
  if (!timeslots?.length) return -1;
  const idx = timeslots.findIndex((s) => !isSlotDisabled(s, eventDateStr));
  return idx >= 0 ? idx : -1;
}
